export const getRelationshipEmoji = (type) => {
  if (!type) return '🤝';
  const map = {
    friend: '👥',
    family: '🏠',
    coworker: '💼',
    colleague: '💼',
    client: '🤝',
    partner: '❤️',
    mentor: '🧭',
    mentee: '📚',
    neighbor: '🏘️',
    acquaintance: '👋',
  };
  return map[type.toLowerCase()] || '🤝';
};
